/**
 * Paddings horizontaux des colonnes de la grille du panier.
 * Gutters asymétriques : plus large sur le bord extérieur de chaque colonne,
 * resserré entre les deux colonnes pour réduire l'espace central.
 */
export const PANIER_GUTTER_LEFT = {
  pl: {base: '2', md: '4', lg: '6'},
  pr: {base: '2', md: '4', lg: '2'},
} as const;

export const PANIER_GUTTER_RIGHT = {
  pl: {base: '2', md: '4', lg: '2'},
  pr: {base: '2', md: '4', lg: '6'},
} as const;
